import { render } from "./BgPaymentAmount.vue?vue&type=template&id=4e97dda9&scoped=true"
import script from "./BgPaymentAmount.vue?vue&type=script&lang=js"
export * from "./BgPaymentAmount.vue?vue&type=script&lang=js"

import "./BgPaymentAmount.vue?vue&type=style&index=0&id=4e97dda9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e97dda9"

export default script